function SvgComponent({ fillColor = '#D378EA', color = 'white', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={fillColor} />
      <path
        d="M15.7327 18.9914C14.0366 19.1465 12.6183 17.1589 11.5312 16.1508C10.9814 20.1117 4.99592 19.7362 5 15.7182C5.00205 14.0306 5 9.90636 5 8.27178C5 7.68407 5.16144 7.09227 5.46389 6.59027C6.03812 5.61687 7.14776 4.98835 8.27784 5.00059C9.98011 5.00263 14.0794 4.99855 15.7327 5.00059C19.7544 5.00059 20.1365 10.9838 16.1618 11.5226L18.0481 13.4061C20.1201 15.3549 18.565 19.0771 15.7327 18.9914ZM14.8192 16.6344C15.9881 17.8385 17.8539 15.9733 16.6502 14.806L13.3805 11.5409H11.5516C11.5516 11.7185 11.5516 13.2408 11.5516 13.3694L14.3778 16.1916L14.8192 16.6344ZM6.98019 15.7202C6.95363 17.3935 9.59593 17.3997 9.56936 15.7202V8.27178C9.59184 7.43715 8.70903 6.77393 7.91205 7.03105C7.87731 7.04126 7.84462 7.05146 7.81396 7.0637C7.31329 7.2494 6.96589 7.76161 6.98019 8.29627V15.7202ZM15.7327 9.56352C17.4125 9.59005 17.4104 6.95146 15.7327 6.97799H11.2921C11.6292 7.68814 11.5434 8.79419 11.5496 9.56352C11.7907 9.56352 15.6141 9.56352 15.7327 9.56352Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
